import { useEffect, useState } from 'react';

export const useTimer = (timeout: number = 1000): [number, (t: number) => void] => {
  const [timer, setTimer] = useState(timeout);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((t) => t + 1);
    }, timeout);
    return () => clearInterval(interval);
  }, [timer, setTimer, timeout]);
  return [timer, setTimer];
};
